
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import languageSelectorDirective from './languageSelector.directive';

const languageSelectorModule = angular.module('languageSelector', [
    uiRouter
  ])
  .directive('stLangSelector', languageSelectorDirective)
  .name;

export default languageSelectorModule;



// WEBPACK FOOTER //
// ./client/app/common/languageSelector/languageSelector.js